"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __importDefault(require("date-fns/format"));
var parse_1 = __importDefault(require("date-fns/parse"));
var react_1 = __importDefault(require("react"));
var DateRangeFilterConfirm_1 = __importDefault(require("../../DateRangeFilterConfirm"));
var LocaleProvider_1 = __importDefault(require("../../LocaleProvider"));
var FilterItem_1 = require("../FilterItem");
var index_1 = __importDefault(require("./index"));
var DateRangeFilterItem = /** @class */ (function (_super) {
    __extends(DateRangeFilterItem, _super);
    function DateRangeFilterItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validOperators = ["between", "lte", "gte", "lt", "gt"];
        _this.onRangeChange = function (fromDate, toDate) {
            var operator;
            var value;
            var from = fromDate ? format_1.default(fromDate, FilterItem_1.FILTER_DATE_FORMAT) : undefined;
            var to = toDate ? format_1.default(toDate, FilterItem_1.FILTER_DATE_FORMAT) : undefined;
            if (from !== undefined && to !== undefined) {
                operator = "between";
                value = [from, to];
            }
            else if (from && to === undefined) {
                operator = "gte";
                value = [from, null];
            }
            else if (to && from === undefined) {
                operator = "lte";
                value = [null, to];
            }
            else {
                operator = "between";
                value = undefined;
            }
            _this.setState({
                selectedValues: [from, to],
            });
            _this.props.onChange(_this.props.id, value, operator);
            _this.closeDialog();
        };
        _this.renderDropdownBody = function () {
            return (react_1.default.createElement("div", { className: "input_container" },
                react_1.default.createElement(DateRangeFilterConfirm_1.default, { from: _this.from, to: _this.to, onChange: _this.onRangeChange })));
        };
        _this.renderLabel = function () {
            var label = _this.props.label || _this.props.id;
            // tslint:disable-next-line: max-line-length
            var fromText = _this.from !== undefined ? (format_1.default(_this.from, LocaleProvider_1.default.locs.date_picker.format)) : (react_1.default.createElement("span", { className: "placeholder" }, LocaleProvider_1.default.locs.datatable.filters.from));
            // tslint:disable-next-line: max-line-length
            var toText = _this.to !== undefined ? (format_1.default(_this.to, LocaleProvider_1.default.locs.date_picker.format)) : (react_1.default.createElement("span", { className: "placeholder" }, LocaleProvider_1.default.locs.datatable.filters.to));
            var text = (react_1.default.createElement(react_1.default.Fragment, null,
                fromText,
                " - ",
                toText));
            return (react_1.default.createElement("div", { className: "input_container" },
                react_1.default.createElement("label", null, label),
                react_1.default.createElement("div", { className: "fake_input fake_input--smallLetterSpacing", onClick: _this.openDialog, style: { textAlign: "center" } }, text)));
        };
        return _this;
    }
    Object.defineProperty(DateRangeFilterItem.prototype, "from", {
        get: function () {
            var selectedValues = this.state.selectedValues;
            var from;
            if (Array.isArray(selectedValues) && selectedValues.length && selectedValues[0]) {
                from = parse_1.default(selectedValues[0], FilterItem_1.FILTER_DATE_FORMAT, new Date());
            }
            return from;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateRangeFilterItem.prototype, "to", {
        get: function () {
            var selectedValues = this.state.selectedValues;
            var to;
            if (Array.isArray(selectedValues) && selectedValues.length === 2 && selectedValues[1]) {
                to = parse_1.default(selectedValues[1], FilterItem_1.FILTER_DATE_FORMAT, new Date());
            }
            return to;
        },
        enumerable: false,
        configurable: true
    });
    DateRangeFilterItem.defaultOperator = "between";
    return DateRangeFilterItem;
}(index_1.default));
exports.default = DateRangeFilterItem;
//# sourceMappingURL=DateRangeFilterItem.js.map